import { BaseModel, enumField, ModelInstance, ToBackHook, ToFrontHook } from './util';
import { GameTimeTypes, OvertimeTypes, RugbyStatisticTypes, TimerTypes } from './tournament';

@ModelInstance({
  mappingFields: {
    periods_count: 'periodsCount',
    period_time: 'periodTime',
    overtime_type: 'overtimeType',
    overtime_time: 'overtimeTime',
    overtime_periods: 'overtimePeriods',
    max_game_players: 'maxGamePlayers',
    game_time_type: 'gameTimeType',
    substitute_count: 'substituteCount',
    free_substitute_enabled: 'freeSubstituteEnabled',
    statistic_type: 'statisticType',
    timer_type: 'timerType',
  },
  relation: {
    overtimeType: enumField(OvertimeTypes),
    gameTimeType: enumField(GameTimeTypes),
    statisticType: enumField(RugbyStatisticTypes),
    timerType: enumField(TimerTypes),
  }
})
export class RugbyGameConfig extends BaseModel {
  periodsCount: number;
  periodTime: number;
  overtimeType: OvertimeTypes;
  overtimeTime: number;
  overtimePeriods: number;
  maxGamePlayers: number;
  gameTimeType: GameTimeTypes;
  substituteCount: number;
  freeSubstituteEnabled: boolean;
  statisticType: RugbyStatisticTypes;
  timerType: TimerTypes;

  get penaltyPeriod(): number {
    if (this.overtimeType !== OvertimeTypes.time_and_penalties) {
      return +this.periodsCount + 1;
    }
    return +this.periodsCount + this.overtimePeriods + 1;
  }

  @ToFrontHook
  static toFront(data: any): any {}

  @ToBackHook
  static toBack(data: any): any {}
}

